import { Link } from "gatsby"
import React from "react"
import { UserIcon } from "components/page-components/Icons/small"

export const HeaderLoginButton = ({ label, link, dropdown_menu_items }) => {
  return (
    <div className="navbar-item has-dropdown is-hoverable">
      <Link to={link} className="header-login-button">
        <div className="m-auto">
          <UserIcon {...{ size: 0.65 }} />
          <span className="ml-3">{label}</span>
        </div>
      </Link>

      <div className="navbar-dropdown is-right is-boxed">
        {dropdown_menu_items.map(({ label, href }, index) => {
          return (
            <a
              key={`login_dropdown_link-${index}`}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="navbar-item has-text-weight-bold has-text-mitternachtsblau"
            >
              {label}
            </a>
          )
        })}
      </div>
    </div>
  )
}
